module.exports = __webpack_public_path__ + "img/lr.1be687fe.svg";